import React from "react";

interface HeaderProps {
  videoUrl: string;
  logoUrl?: string;
  logoAlt: string;
  fallbackImageUrl: string;
  hiddenRoutes: boolean;
}

const Header: React.FunctionComponent<HeaderProps> = ({ videoUrl, logoUrl, logoAlt, fallbackImageUrl, hiddenRoutes }) => {

  if (hiddenRoutes) return null;
  
  const headerStyle: React.CSSProperties = {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  };

  const videoStyle: React.CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -2,
  };

  const overlayStyle: React.CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: -1,
  };

  const logoStyle: React.CSSProperties = {
    zIndex: 1,
    width: "55vh",
    height: "auto",
    opacity: 0,
    animation: "fadeIn 2s ease-in-out forwards",
  };

  const textContainerStyle: React.CSSProperties = {
    position: "absolute",
    top: "64%",
    left: "30%",
    transform: "translate(-50%, -50%) rotate(-17deg)",
    textAlign: "center",
    zIndex: 1,
    fontSize: "6vmax",
    fontFamily: "Alfa Slab One",
    fontWeight: 300,
    opacity: 0,
    animation: "fadeInText 3s ease-in-out 2s forwards",
  };

  const glutenFreeStyle: React.CSSProperties = {
    color: "#A67C52",
    marginTop: "-1.8rem",
  };

  return (
    <header style={headerStyle}>
      {/* Hintergrundvideo */}
      <div style={{ ...videoStyle }}>
        <video
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* Schwarzer Filter */}
      <div style={overlayStyle}></div>
      {/* Logo */}
      {logoUrl && (<img src={logoUrl} alt={logoAlt} style={logoStyle} />)}
      {/* Schriftzüge */}
      <div style={textContainerStyle}>
        <div style={{ color: "#77A04A" }}>Bio</div>
        <div style={glutenFreeStyle}>Glutenfrei</div>
      </div>
    </header>
  );
};

export default Header;
